import React from "react";
import { Icon as IconComponent } from "@cadmakers-ui/icons";
import styles from "../../Styles/SidebarIcon.module.scss";
import { Icon as IconType } from "../../../Common/Types/Icon";

type Props = {
  icon: IconType;
};

export const SidebarOptionIcon = (props: Props) => {
  return <IconComponent {...props.icon} />;
};
